import * as React from 'react';

import { Lazy } from 'components/common/lazy/lazy';
import { ListingGallery } from './listing-gallery';
import { RenderGalleryProps } from './title';
import { TitleImage } from './title-image';

export const TitleGallery: React.FunctionComponent<RenderGalleryProps> = ({ listingGalleryProps, renderImageProps, lazyLoadImg }) => {
  const imageUrl = renderImageProps.imageUrl;

  return (
    <React.Fragment>
      {lazyLoadImg && (
        <Lazy key={`lazy-${imageUrl}`} loadOffset={{ top: 350, bottom: 350 }}>
          <Lazy.Placeholder key={`lazy-placeholder-${imageUrl}`}>
            <TitleImage renderImg={renderImageProps} serverRender={true} />
          </Lazy.Placeholder>
          <Lazy.Loaded key={`lazy-loaded-${imageUrl}`}>
            <ListingGallery {...listingGalleryProps} />
          </Lazy.Loaded>
        </Lazy>
      )}
      {!lazyLoadImg && <ListingGallery {...listingGalleryProps} />}
    </React.Fragment>
  );
};
